import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Form, Input, Label } from 'semantic-ui-react';
import { useDidUpdate, useToggle } from '../../lib/hooks';

import { useForm } from '../../hooks';

import styles from './LineAdd.module.scss';

const DEFAULT_DATA = {
  name: '',
};

const LineAdd = React.memo(({ listLine, onCreate, onClose }) => {
  const [t] = useTranslation();
  const [data, handleFieldChange, setData] = useForm(DEFAULT_DATA);
  const [selectNameFieldState, selectNameField] = useToggle();

  const nameField = useRef(null);

  const handleFieldKeyDown = useCallback(
    (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    },
    [onClose],
  );

  const handleSubmit = useCallback(() => {
    const cleanData = {
      ...data,
      name: data.name.trim(),
    };

    if (!cleanData.name) {
      nameField.current.select();
      return;
    }

    onCreate(cleanData);

    setData(DEFAULT_DATA);
    selectNameField();
    onClose();
  }, [onCreate, data, setData, selectNameField, onClose]);

  useEffect(() => {
    nameField.current.select();
  }, []);

  useDidUpdate(() => {
    nameField.current.select();
  }, [selectNameFieldState]);

  const lineOptions = [];
  lineOptions.push({ key: 0, value: 0, text: t('common.none') });
  listLine.forEach((item) => lineOptions.push({ key: item.id, value: item.id, text: item.name }));

  return (
    <>
      <Modal open closeIcon size="tiny" onClose={onClose}>
        <Modal.Header>
          {t('common.createLine_title', {
            context: 'title',
          })}
        </Modal.Header>
        <Modal.Content>
          <Form className={styles.wrapper} onSubmit={handleSubmit}>
            <Label>{t('common.enterLineTitle')}</Label>
            <Input
              ref={nameField}
              name="name"
              value={data.name}
              placeholder={t('common.enterLineTitle')}
              className={styles.field}
              onKeyDown={handleFieldKeyDown}
              onChange={handleFieldChange}
            />
            {/* <Label>{t('common.selectLineParent')}</Label>
            <Dropdown
              className={styles.fieldDropdown}
              placeholder={t('common.selectLineParent')}
              search
              fluid
              selection
              options={lineOptions}
              defaultValue="0"
            /> */}
            <div className={styles.controls}>
              <Button
                color="green"
                icon="checkmark"
                content={t('action.addLine')}
                floated="right"
                positive
                className={styles.submitButton}
              />
            </div>
          </Form>
        </Modal.Content>
      </Modal>
    </>
  );
});

LineAdd.propTypes = {
  listLine: PropTypes.arrayOf(PropTypes.any).isRequired,
  onCreate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default LineAdd;
